import { Injectable } from '@angular/core';
import { MySocket } from '@app/core/services/socketio.service';
import { Relay } from '../models/relay';
import { ResponseError } from '@app/core/models/error';
import { PagedResultRelay } from '../models/paged-result-relay';
import { ApiService } from './api.service';


@Injectable({
  providedIn: 'root'
})

export class RelayService {
  public onListAll$ = this.socket.fromEvent<PagedResultRelay>('relay/on-list-all');

  public onGet$ = this.socket.fromEvent<Relay>('relay/on-get');
  public onGetError$ = this.socket.fromEvent<ResponseError>('relay/on-get-error');

  public onDeleteRelay$ = this.socket.fromEvent<Relay>('relay/on-delete');
  public onDeleteRelayError$ = this.socket.fromEvent<ResponseError>('relay/on-delete-error');

  public onCreateRelay$ = this.socket.fromEvent<Relay>('relay/on-create');
  public onCreateRelayError$ = this.socket.fromEvent<ResponseError>('relay/on-create-error');

  public onUpdateRelay$ = this.socket.fromEvent<Relay>('relay/on-update');
  public onUpdateRelayError$ = this.socket.fromEvent<ResponseError>('relay/on-update-error');

  public onGetCurrentRelays$ = this.socket.fromEvent<Relay[]>('relay/on-get-current');

  public onSearchRelay$ = this.socket.fromEvent<Relay[]>('relay/on-search');
  public onSearchRelayError$ = this.socket.fromEvent<ResponseError>('relay/on-search-error');

  constructor(
    private socket: MySocket,
    private apiService: ApiService
  ) { }

  getRelays(params: any) {
    this.socket.emit('relay/do-list-all', this.apiService.gridEventToApi(params));
  }

  getRelay(id: number) {
    this.socket.emit('relay/do-get', {'id': id});
  }

  updateRelay (relay: Relay) {
    this.socket.emit('relay/do-update', relay);
  }

  addRelay (relay: Relay) {
    this.socket.emit('relay/do-create', relay);
  }

  deleteRelay (relay: Relay) {
    this.socket.emit('relay/do-delete', relay);
  }

  searchRelay(query: string) {
    this.socket.emit('relay/do-search', {'query': query});
  }

  getCurrentRelays() {
    this.socket.emit('relay/do-get-current');
  }
}
